module.exports = __webpack_public_path__ + "static/media/Hui Li.aefbe978.png";